import script from "./ExamSetupPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ExamSetupPage.vue?vue&type=script&setup=true&lang=js"

import "./ExamSetupPage.vue?vue&type=style&index=0&id=07aac1ac&lang=css"

const __exports__ = script;

export default __exports__